import { useReleaseNotesControls } from './releaseNotesContext';

export default function AppVersion() {
  const version = import.meta.env.VITE_APP_VERSION || '0.0.0-local';
  const controls = useReleaseNotesControls();
  if (!controls) {
    return <span style={{ fontSize: 12, color: '#71717a' }}>v{version}</span>;
  }
  return (
    <button
      type="button"
      onClick={controls.openHistory}
      style={{
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        color: '#71717a',
        fontSize: 12,
        borderBottom: '1px dotted #d4d4d8',
      }}
    >
      v{version} · What's new
    </button>
  );
}
